import { RECRUITERCLIENTDASHBOARDJOBCOUNT } from "../../ENVIRONMENT";

// api for recruiter dashboard job count
function recdashboardJobCount(token) {
  const response = fetch(RECRUITERCLIENTDASHBOARDJOBCOUNT, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { recdashboardJobCount };
